import { render, staticRenderFns } from "./KeywordsComponent.vue?vue&type=template&id=049e99da&scoped=true"
import script from "./KeywordsComponent.vue?vue&type=script&lang=js"
export * from "./KeywordsComponent.vue?vue&type=script&lang=js"
import style0 from "./KeywordsComponent.vue?vue&type=style&index=0&id=049e99da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e99da",
  null
  
)

export default component.exports